import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "topic-analyze"
};
var _hoisted_2 = {
  class: "topic-flx",
  style: {
    "margin-bottom": "14px"
  }
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  class: "topic-flx"
};
var _hoisted_5 = ["innerHTML"];
import { ref, onMounted, toRefs } from 'vue';
import { useRoute } from 'vue-router';

// 接收每一条习题的数据

export default {
  __name: 'QuestionAnalysis',
  props: {
    question: {
      type: Object
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      question = _toRefs.question;
    var route = useRoute();
    var reply = ref(''); // 答案
    onMounted(function () {
      reply.value = _getQuestionReply(question.value.type, question.value) || '';
    });
    var _getQuestionReply = function getQuestionReply(type, val) {
      // 单选题/多选题
      if (type === 'SINGLE_CHOICE' || type === 'MULTIPLE_CHOICE') {
        var options = val.options;
        return options.filter(function (obj) {
          return obj.isCorrect;
        }).map(function (obj) {
          return obj.code;
        });
        // 判断题
      } else if (type === 'JUDGE') {
        var _options = val.options;
        return _options.filter(function (obj) {
          return obj.isCorrect;
        }).map(function (obj) {
          return obj.content;
        });
        // 填空题
      } else if (type === 'COMPLETION') {
        var fillBlanks = val.fillBlanks;
        return fillBlanks.map(function (obj) {
          return obj.correct;
        });
        // 简答题
      } else if (type === 'ANSWER_QUESTIONS') {
        return val.answer.correct;
        // 综合题
      } else {
        if (val.childs) {
          var childs = val.childs;
          // 取第一个值
          var _reply = '';
          var idx = -1;
          // 递归取值
          childs.forEach(function (item) {
            var res = _getQuestionReply(item.type, item);
            if (Array.isArray(res) && res.every(function (value) {
              return value === null;
            })) {
              _reply = _reply + "<p>(".concat(idx + 2, ") </p>");
            } else {
              res = res ? res.toString().replace(/<p>|<\/p>/g, '') : '';
              _reply = _reply + "<p>(".concat(idx + 2, ") ").concat(res, "</p>");
            }
            idx += 1;
          });
          return _reply;
        }
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "reply tag"
      }, "答", -1)), _createElementVNode("div", {
        innerHTML: "<p>".concat(reply.value, "</p>"),
        class: _normalizeClass(["reply-text", {
          grid: _unref(question).type === 'COMPREHENSIVE'
        }])
      }, null, 10, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "solution tag"
      }, "解", -1)), _createElementVNode("div", {
        innerHTML: "<p>".concat(_unref(question).analysis || '', "</p>"),
        class: "reply-text"
      }, null, 8, _hoisted_5)])]);
    };
  }
};